/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Status_PendingInputs */

const vi_tea_purchase_status_pending = /** @type {(inputs: Tea_Purchase_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa duyệt`)
};

/**

* @param {Tea_Purchase_Status_PendingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_status_pending = /** @type {((inputs?: Tea_Purchase_Status_PendingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Status_PendingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_status_pending(inputs)
});